import $ from "jQuery";
import ky from 'ky';

let gPreferredHost = undefined;
let gNATToken = null; // This determines whether or not we're talking to a local MM from hosted environment (via NAT).
let gSerialNumber = null; // Used for requests to the local MM

function setSerialNumber(pSerialNumber) {
  gSerialNumber = pSerialNumber;
}

function forwardRequestToMachineMotion(pPayload) {
  return ky.post(gPreferredHost + "/notify", {
    json: pPayload,
    headers: {
      Authorization: gNATToken,
    }
  }).json();
}

/**
 * doAjax
 * Depending on the context, either performs plain $.ajax, or sends that same request via reverse proxy communication channel.
 */
function doAjax(pAjaxOptions) {
  if (!gPreferredHost) {
    throw new Error("You are trying to send an http request without having set the remote host beforehand. Make sure you call api_request::setRemoteHost");
  }

  if (gNATToken) {
    // When we're in a scenario of NAT traversal (i.e. vention.io talking to a local MM behind NAT),
    // send the request via that special reverse-proxy channel.
    const regexToPath = new RegExp("(?<=" + gPreferredHost + ").*$", "ig");
    const lPayloadToNAT = {
      payload: pAjaxOptions.data ? JSON.parse(pAjaxOptions.data) : {},
      http: {
        method: pAjaxOptions.type,
        path: pAjaxOptions.url.match(regexToPath)[0],
      },
      serialNumber: gSerialNumber,
    };

    return forwardRequestToMachineMotion(lPayloadToNAT)
      .then((response) => {
        pAjaxOptions.success(response);
      })
      .catch((error) => {
        pAjaxOptions.error(error);
      });
  } else {
    // Otherwise, send directly.
    $.ajax(pAjaxOptions);
  }
}

function doAjaxPromise(url, options) {
  if (!gPreferredHost) {
    throw new Error("You are trying to send an http request without having set the remote host beforehand. Make sure you call api_request::setRemoteHost");
  }

  if (!options) {
    options = { method: "GET" };
  }

  if (undefined != gNATToken) {
    // When we're in a scenario of NAT traversal (i.e. vention.io talking to a local MM behind NAT),
    // send the request via that special reverse-proxy channel.
    const regexToPath = new RegExp("(?<=" + gPreferredHost + ").*$", "ig");
    const FIRST_MATCH = 0;

    const lPayloadToNAT = {
      payload: options.body ? JSON.parse(options.body) : {},
      http: {
        method: options.method || options.type,
        path: url.match(regexToPath)[FIRST_MATCH],
      },
      serialNumber: gSerialNumber,
    };

    return fetch(gPreferredHost + "/notify", {
      method: "POST",
      body: JSON.stringify(lPayloadToNAT),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: gNATToken,
      },
    })
      .then(function callbackPush(x) {
        console.log("Pushed VSE program successfully to machine-motion", x);
        return x;
      })
      .catch(function errorPush() {
        console.warn("Failed to push VSE program to machine-motion");
      });
  } else {
    // Otherwise, send directly.
    return fetch(url, options);
  }
}

function isNATed() {
  return undefined != gNATToken;
}

/**
 * @callback requestCallback
 * @param {Object} responseObject
 */

/**
 * Sets the remote host for future api requests.
 *
 * @param {string} pRemoteHost
 * @param {string} [pNATToken]
 * @param {string} [pSerialNumber]
 */
function setRemoteHost(pRemoteHost, pNATToken, pSerialNumber) {
  if (!pRemoteHost) {
    console.warn(`api_request::setRemoteHost called without a remote host. ${{ pRemoteHost, pNATToken }}`);
  }

  gPreferredHost = pRemoteHost || gPreferredHost;
  gNATToken = pNATToken;
  gSerialNumber = pSerialNumber;
}

function getRemoteHost() {
  return gPreferredHost;
}

export { doAjax, doAjaxPromise, setRemoteHost, getRemoteHost, isNATed, setSerialNumber };